/** @jsx jsx */
import { jsx } from '@emotion/core';
import { Text, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import defaultsDeep from 'lodash/defaultsDeep';
import compose from 'lodash/fp/compose';
import get from 'lodash/get';
import { withNamespaces } from 'react-i18next';
import { getshowStyles } from '../../../utils/responsive';
import { getPrefilledSolutionValue } from '../../../utils/getPrefilledSolutionValue';
import Spacer from '../../ui/Spacer';
import DotComponent from '../../ui/DotComponent';
import OpenEnquiryFormButton from '../../ui/OpenEnquiryFormButton';
import { MediaQueries } from '../../../styles/Grid';
import { Container, Row, Column } from '../../../styles/Grid';
import { Placeholder } from '@sitecore-jss/sitecore-jss-react';
import { SafePureComponent } from '../../../utils/SafePureComponent';
import {
  containerMarginCss,
  containerPaddingCss,
  headlineCss,
  bodyCss,
  contactCss,
} from './index.styles';
// import { PhoneNumber } from '../../ui/Form';
// import { ContactLineNumber } from '../ContactLineNumber';
import { Icon } from '../../ui/Icon';
import LinkWrapper from '../../ui/LinkWrapper';

const defaultData = {
  BackgroundColor: { fields: { Value: { value: 'brown10' } } },
  FaqHeadline: { value: '' },
  FaqContentText: { value: '' },
  LocalPhoneNumber: { value: '' },
};

export class SolutionFaq extends SafePureComponent {
  renderGetInTouchCTA() {
    const linkObject = get(this.props, 'fields.CTALink', '');
    const CTAText = get(this.props, 'fields.CTAText.value', '');
    linkObject.value.text = CTAText;
    const componentName = get(this.props, 'rendering.componentName', '');

    return (
      <LinkWrapper
        field={linkObject}
        componentName={componentName}
        isGTMTrackable
      />
    );
    // const openEnquiryFormButtonProps = {
    //   prefilledValues: {
    //     Solution: getPrefilledSolutionValue(this.props.sitecoreContext),
    //   },
    // };
    // const componentName = get(this.props, 'rendering.componentName', '');

    // return (
    //   <OpenEnquiryFormButton
    //     {...openEnquiryFormButtonProps}
    //     componentName={componentName}
    //   />
    // );
  }

  safeRender() {
    const { props } = this;

    const fields = defaultsDeep(props.fields, defaultData);
    const PhoneNumber = get(fields, 'PhoneNumber.value', '');
    const CallUsText = get(fields, 'CallUsText.value', '');
    const {
      BackgroundColor,
      FaqHeadline,
      FaqContentText,
      CTAText,
      // CallUsText,
      // PhoneNumber,
    } = fields;

    return (
      <Spacer
        backgroundColor={BackgroundColor}
        marginCss={containerMarginCss}
        paddingCss={containerPaddingCss}
        containerProps={{ 'data-sticky-id': get(props, 'rendering.uid') }}
      >
        <Container>
          <Row>
            <Column cols={{ sm: 6, md: 7, lg: 4, xl: 4 }}>
              <h3 css={headlineCss}>
                <Text field={FaqHeadline} />
                <DotComponent />
              </h3>
              <Row css={getshowStyles(MediaQueries.lgAndUp, 'flex')}>
                <Column>
                  <p css={bodyCss}>
                    <Text field={FaqContentText} />
                  </p>
                </Column>
              </Row>
              <Row css={getshowStyles(MediaQueries.lgAndUp, 'flex')}>
                <Column>
                  <div css={contactCss}>
                    {/* <Placeholder name="jss-phone" rendering={props.rendering} /> */}

                    {PhoneNumber && (
                      <a href={`tel:${PhoneNumber}`} className="Callussection">
                        <span>
                          <Icon name="contact" className="phone-default-icon" />
                        </span>
                        <span className="callustxt">{CallUsText}</span>
                        <span>{PhoneNumber}</span>
                      </a>
                    )}
                  </div>
                </Column>
              </Row>
              <Row css={getshowStyles(MediaQueries.lgAndUp, 'block')}>
                <Column
                  className="getintouchcta"
                  cols={{ sm: [6, 6], md: [7, 7], lg: [3, 4], xl: [2, 4] }}
                >
                  {this.renderGetInTouchCTA()}
                </Column>
              </Row>
            </Column>
            <Column
              className="seemore_sec"
              cols={{ sm: 6, md: 8, lg: 7 }}
              offsets={{ lg: 1 }}
            >
              <Placeholder
                fields={{
                  BackgroundColor: 'brown10',
                  hideSpacer: true,
                }}
                name="jss-accordion-right"
                rendering={props.rendering}
              />
            </Column>
          </Row>
        </Container>
      </Spacer>
    );
  }
}

SolutionFaq.displayName = 'SolutionFaq';

SolutionFaq.defaultProps = {
  fields: defaultData,
  t: key => key,
};

export default compose(withSitecoreContext(), withNamespaces())(SolutionFaq);
